import React, { useState, useEffect } from "react";
import { FaDatabase, FaUserFriends } from "react-icons/fa";
import { Container, Row, Col, Stack, Badge, Button, Form, ListGroup, ToggleButton, ProgressBar } from "react-bootstrap";
import { TODIS_BTN_PRIMARY, TODIS_BTN_SECUNDARY, TODIS_DATEPICKER, TODIS_OUTLINE_BTN, TODIS_SUCCESS_BTN } from "../../components/Buttons";
import "../DataCollection/style.css";
import globe from "../../assets/icons/globe.svg";
import forms from "../../assets/icons/forms.svg";
import style from "./Admin.module.scss" 
import { BsPlusLg, BsBuilding } from "react-icons/bs";
import { BiBlock } from "react-icons/bi";

const Requests = () => {

    return (
        <>
        <Col sm={4} >
            <Container fluid className="todis-form-wrapper p-4 pb-0">
                <Row className="todis-form-action-panel" style={{borderBottom: "10px solid #E3F2FD"}}>
                    <Col lg={12} className="ps-4">
                        <div className="pb-2" style={{borderBottom: "3px solid #e3f2fd"}}>
                            <Row>
                                <Col lg={6} style={{alignSelf: "center"}}>
                                    <Stack gap={0}>
                                        <h4 className={style.title}>System Users</h4>
                                    </Stack>
                                </Col>
                                <Col lg={6}>
                                    <Button variant="outline-primary" onClick={() => {}} className={`${style.buttonAdmin} ${"todis-reset-btn float-end"}`}><BsPlusLg className="me-3" size="16"/> CREATE NEW USER </Button>
                                </Col>
                            </Row>
                        </div>
                    </Col>
                    <Col lg={12}>
                        <Row style={{padding: "25px 0px 0px 20px"}}>
                            <Col lg={3}>
                                <span><FaUserFriends size={120} color="#004494" style={{paddingRight: "14px"}}/></span>
                            </Col>
                            <Col lg={4} style={{alignSelf: "center"}}>
                                <h5 style={{fontWeight: "700",color: "grey"}}>Total Users</h5>
                                <h1 style={{fontWeight: "700", fontSize: "xxx-large"}}>40</h1>  
                            </Col>
                            <Col lg={5}>
                                <Button variant="primary" className={`${style.buttonAdmin} ${"todis-submit-btn bck-btn-primary w-100"}`} >VIEW ALL USERS </Button>
                            </Col>
                            <Col lg={12}>
                                <div>
                                    <span style={{position: "relative",float: "left",fontWeight: "700",fontSize: "18px", color: "grey"}}>Serbia</span>
                                </div>
                                <div>
                                    <span style={{position: "relative",float: "right",fontWeight: "700",fontSize: "18px"}}>15 | 40</span>
                                </div>
                            </Col>
                            <Col lg={12}>
                                <Row>
                                    <Col lg={2}>
                                        <span style={{fontSize: "16px",fontWeight: "700"}}>15 Users</span>
                                    </Col>
                                    <Col lg={10} style={{alignSelf: "center"}}>
                                        <ProgressBar now={((15*100)/40)} color="#004494"/>
                                    </Col>
                                </Row>
                            </Col>
                            <Col lg={12}>
                                <div>
                                    <span style={{position: "relative",float: "left",fontWeight: "700",fontSize: "18px", color: "grey"}}>Albania</span>
                                </div>
                                <div>
                                    <span style={{position: "relative",float: "right",fontWeight: "700",fontSize: "18px"}}>5 | 40</span>
                                </div>
                            </Col>
                            <Col lg={12}>
                                <Row>
                                    <Col lg={2}>
                                        <span style={{fontSize: "16px",fontWeight: "700"}}>5 Users</span>
                                    </Col>
                                    <Col lg={10} style={{alignSelf: "center"}}>
                                        <ProgressBar now={((5*100)/40)} color="#004494"/>
                                    </Col>
                                </Row>
                            </Col>
                            <Col lg={12}>
                                <div>
                                    <span style={{position: "relative",float: "left",fontWeight: "700",fontSize: "18px", color: "grey"}}>Serbia</span>
                                </div>
                                <div>
                                    <span style={{position: "relative",float: "right",fontWeight: "700",fontSize: "18px"}}>10 | 40</span>
                                </div>
                            </Col>
                            <Col lg={12}>
                                <Row>
                                    <Col lg={2}>
                                        <span style={{fontSize: "16px",fontWeight: "700"}}>10 Users</span>
                                    </Col>
                                    <Col lg={10} style={{alignSelf: "center"}}>
                                        <ProgressBar now={((10*100)/40)} color="#004494"/>
                                    </Col>
                                </Row>
                            </Col>
                            <Col lg={12}>
                                <div>
                                    <span style={{position: "relative",float: "left",fontWeight: "700",fontSize: "18px", color: "grey"}}>Serbia</span>
                                </div>
                                <div>
                                    <span style={{position: "relative",float: "right",fontWeight: "700",fontSize: "18px"}}>10 | 40</span>
                                </div>
                            </Col>
                            <Col lg={12}>
                                <Row>
                                    <Col lg={2}>
                                        <span style={{fontSize: "16px",fontWeight: "700"}}>10 Users</span>
                                    </Col>
                                    <Col lg={10} style={{alignSelf: "center"}}>
                                        <ProgressBar now={((10*100)/40)} color="#004494"/>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Col>
                    <Col lg={12} className="ps-4 pt-4">
                    </Col>
                </Row>
                <Row className="pb-3 pt-3" style={{overflow: "auto", maxHeight: "660px"}}>
                    <Col lg={12} className="ps-4">
                        <div className="pb-2" style={{borderBottom: "3px solid #e3f2fd"}}>
                            <Row>
                                <Col lg={4} style={{alignSelf: "center"}}>
                                    <Stack gap={0}>
                                        <h4 className={style.title}>Organizations</h4>
                                    </Stack>
                                </Col>
                                <Col lg={8}>
                                    <Button variant="outline-primary" onClick={() => {}} className={`${style.buttonAdmin} ${"todis-reset-btn float-end"}`}><BsPlusLg className="me-3" size="16"/> CREATE NEW ORGANIZATION </Button>
                                </Col>
                            </Row>
                        </div>
                    </Col>
                    <Col lg={12}>
                        <Row style={{padding: "25px 0px 0px 20px"}}>
                            <Col lg={3}>
                                <span><BsBuilding size={120} color="#004494" style={{paddingRight: "14px"}}/></span>
                            </Col>
                            <Col lg={9} style={{alignSelf: "center"}}>
                                <h5 style={{fontWeight: "700",color: "grey"}}>Total Organizations</h5>
                                <h1 style={{fontWeight: "700", fontSize: "xxx-large"}}>56</h1>  
                            </Col>
                            <Col lg={12}>
                                <Button variant="outline-primary" onClick={() => {}} className={`${style.buttonAdmin} ${"todis-reset-btn float-end w-50"}`}>VIEW ORGANIZATIONS </Button>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Container>
        </Col>
        <Col sm={4} >
            <Container fluid className="todis-form-wrapper p-4 pb-0">
                <Row className="todis-form-action-panel" style={{borderBottom: "10px solid #E3F2FD"}}>
                    <Col lg={12} className="ps-4">
                        <div className="pb-2" style={{borderBottom: "3px solid #e3f2fd"}}>
                            <Row>
                                <Col lg={6} style={{alignSelf: "center"}}>
                                    <Stack gap={0}>
                                        <h4 className={style.title}>System Performance</h4>
                                    </Stack>
                                </Col>
                                <Col lg={6}>
                                    <Button variant="outline-primary" onClick={() => {}} className={`${style.buttonAdmin} ${"todis-reset-btn float-end"}`}> CONFIGURATION </Button>
                                </Col>
                            </Row>
                        </div>
                    </Col>
                    <Col lg={12}>
                        <Row className="float-end" style={{height: "255px"}}>
                        </Row>
                    </Col>
                </Row>
                <Row className="pb-3 pt-3" style={{overflow: "auto", maxHeight: "660px"}}>
                    <Col lg={12}>
                        <div className="pb-2" style={{borderBottom: "3px solid #e3f2fd"}}>
                            <Row>
                                <Col lg={6} style={{alignSelf: "center"}}>
                                    <Stack gap={0}>
                                        <h4 className={style.title}>System Components</h4>
                                    </Stack>
                                </Col>
                            </Row>
                        </div>
                    </Col>
                    <Col lg={12} style={{border: "1px solid #E3F2FD", borderRadius: "20px" ,marginTop: "25px"}}>
                        <Row>
                            <Col lg={2}>
                                <img src={forms} width="73" className="mx-auto" />
                            </Col>
                            <Col lg={7} style={{alignSelf: "center"}}>
                                <h4 className={style.title}>Data Collection</h4>
                            </Col>
                            <Col lg={3} style={{alignSelf: "center"}}>
                                <Button onClick={() => {}} className={`${style.buttonAdmin} ${"todis-reset-btn float-end w-100"}`} style={{background: "#e3f2fd"}}><BiBlock className="me-3" size="16"/>Stop </Button>
                            </Col>
                            <Col lg={12} style={{textAlign: "justify"}}>
                                <span>
                                    Lorem ipsum is simply dummy text of the printing and typesetting industry. Lorem ipsum has been the industry's standard dummy text ever since the 1500s, Lorem.
                                </span>
                            </Col>
                        </Row>
                    </Col>
                    <Col lg={12} style={{border: "1px solid #E3F2FD", borderRadius: "20px" ,marginTop: "25px"}}>
                        <Row>
                            <Col lg={2}>
                                <img src={globe} width="73" className="mx-auto" />
                            </Col>
                            <Col lg={7} style={{alignSelf: "center"}}>
                                <h4 className={style.title}>Data Sharing</h4>
                            </Col>
                            <Col lg={3} style={{alignSelf: "center"}}>
                                <Button onClick={() => {}} className={`${style.buttonAdmin} ${"todis-reset-btn float-end w-100"}`} style={{background: "#e3f2fd"}}><BiBlock className="me-3" size="16"/>Stop </Button>
                            </Col>
                            <Col lg={12} style={{textAlign: "justify"}}>
                                <span>
                                    Lorem ipsum is simply dummy text of the printing and typesetting industry. Lorem ipsum has been the industry's standard dummy text ever since the 1500s, Lorem.
                                </span>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Container>
        </Col>
        <Col sm={4} >
            <Container fluid className="todis-form-wrapper p-4">
                <Row className="todis-form-action-panel" style={{borderBottom: "10px solid #E3F2FD"}}>
                    <Col lg={12} className="ps-4">
                        <div className="pb-3" style={{borderBottom: "3px solid #e3f2fd"}}>
                            <Row>
                                <Col lg={12} style={{alignSelf: "center"}}>
                                    <Stack gap={0}>
                                        <h4 className={style.title}><FaDatabase size={24} color="#004494" className="me-3"/>Generate TODIS Backup</h4>
                                    </Stack>
                                </Col>
                            </Row>
                        </div>
                    </Col>
                    <Row>
                        <Col lg={12} style={{paddingBlock: "20px", paddingleft: "25px", textAlign: "justify"}}>
                            <span>
                                Lorem ipsum is simply dummy text of the printing and typesetting industry. Lorem ipsum has been the industry's standard dummy text ever since the 1500s, Lorem.
                            </span>
                        </Col>
                        <Col lg={12} style={{paddingBottom: "15px"}}>
                                <Button onClick={() => {}} className={style.buttonBackup}>GENERATE BACKUP</Button>
                        </Col>
                    </Row>
                </Row>
            </Container>
        </Col>
        </>
    );
}

export default Requests;